import { Component, Input } from '@angular/core';

import { Plan } from '@catalog/products/subscription/plan';

import { ApiFunding, ApiProduct, ApiPromos } from '@app/baseBtl/catalog/products/interface/context';

interface BasicObj {
    [key: string]: any;
}

@Component({
    templateUrl: './price-details-modal.component.html',
    styleUrls: ['./price-details-modal.component.scss'],
})
export class PriceDetailsModalComponent {
    @Input() device: ApiProduct;
    @Input() plan: Plan;
    @Input() fundingKey: string;
    @Input() isWithoutTax: boolean = false;

    public discountWithPlan: number;
    public instantDiscount: number;
    public priceWithOdr: number;
    public funding: ApiFunding;
    public odr: ApiPromos;
    public planDuration: number;
    public deviceLabel: string;

    ngOnInit(): void {
        const prices = this.device?.prix;

        this.planDuration = Number((this.plan?.obligation || '0').replace(/[^\d]/g, ''));
        this.discountWithPlan = prices.subventionne ? prices.initial - prices.subventionne : 0;
        this.instantDiscount = (prices.subventionne || prices.initial) - prices.final;
        this.funding =
            this.device?.financements.find((funding: ApiFunding) => funding.type === this.fundingKey) ||
            this.device?.financements[0];
        this.odr = this.device?.promotions.find((promo: ApiPromos) => promo.type === 'ODR');
        this.priceWithOdr = prices.final - (this.odr?.reduction || 0) + (this.funding?.montantInteret || 0);
        this.setDeviceLabel();
    }

    private setDeviceLabel(): void {
        if (this.device.type.includes('accessory')) {
            this.deviceLabel = "de l'accessoire";
        } else if (this.device.type.includes('box')) {
            this.deviceLabel = "de l'équipement";
        } else {
            this.deviceLabel = 'du téléphone';
        }
    }
}
